var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, IsUUID, MaxLength, MinLength, ValidateNested } from 'class-validator';
import { UpdateExerciseProgramItemDto } from '../../exercise-programs/dtos/update-exercise-program-item.dto.js';
export class UpdateExerciseTemplateDto {
    name;
    exerciseTemplateFolderIds = [];
    exerciseProgramItems;
}
__decorate([
    IsOptional(),
    Expose(),
    MinLength(1),
    MaxLength(255),
    __metadata("design:type", String)
], UpdateExerciseTemplateDto.prototype, "name", void 0);
__decorate([
    IsArray(),
    IsUUID(4, { each: true }),
    Expose(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateExerciseTemplateDto.prototype, "exerciseTemplateFolderIds", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => UpdateExerciseProgramItemDto),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateExerciseTemplateDto.prototype, "exerciseProgramItems", void 0);
//# sourceMappingURL=update-exercise-template.dto.js.map